module.exports = __webpack_public_path__ + "static/img/71 (1).9b92a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/71 (1).jpg
// module id = 9CdE
// module chunks = 0